import * as React from "react";
import simpleFacebookIcon from "@iconify-icons/simple-icons/facebook";
import simpleInstagramIcon from "@iconify-icons/simple-icons/instagram";
import simpleLinkedinIcon from "@iconify-icons/simple-icons/linkedin";
import simpleThreadsIcon from "@iconify-icons/simple-icons/threads";
import simpleTiktokIcon from "@iconify-icons/simple-icons/tiktok";
import simpleXIcon from "@iconify-icons/simple-icons/x";
import simpleYoutubeIcon from "@iconify-icons/simple-icons/youtube";
import accessibleIcon from "@iconify-icons/material-symbols/accessible-rounded";
import activityIcon from "@iconify-icons/material-symbols/local-activity-rounded";
import addIcon from "@iconify-icons/material-symbols/add-rounded";
import addPhotoAlternateIcon from "@iconify-icons/material-symbols/add-photo-alternate-rounded";
import adsClickIcon from "@iconify-icons/material-symbols/ads-click-rounded";
import apartmentIcon from "@iconify-icons/material-symbols/apartment-rounded";
import arrowBackIcon from "@iconify-icons/material-symbols/arrow-back-rounded";
import arrowDownwardIcon from "@iconify-icons/material-symbols/arrow-downward-rounded";
import arrowForwardIcon from "@iconify-icons/material-symbols/arrow-forward-rounded";
import arrowUpwardIcon from "@iconify-icons/material-symbols/arrow-upward-rounded";
import articleIcon from "@iconify-icons/material-symbols/article-rounded";
import assignmentIndIcon from "@iconify-icons/material-symbols/assignment-ind";
import autoAwesomeIcon from "@iconify-icons/material-symbols/auto-awesome-rounded";
import barChartIcon from "@iconify-icons/material-symbols/bar-chart-rounded";
import balconyIcon from "@iconify-icons/material-symbols/balcony-rounded";
import bathroomIcon from "@iconify-icons/material-symbols/bathroom-rounded";
import bathtubIcon from "@iconify-icons/material-symbols/bathtub-rounded";
import bedIcon from "@iconify-icons/material-symbols/bed-rounded";
import bedroomChildIcon from "@iconify-icons/material-symbols/bedroom-child-rounded";
import bedroomParentIcon from "@iconify-icons/material-symbols/bedroom-parent-rounded";
import boltIcon from "@iconify-icons/material-symbols/bolt-rounded";
import calendarMonthIcon from "@iconify-icons/material-symbols/calendar-month-rounded";
import callIcon from "@iconify-icons/material-symbols/call";
import cancelIcon from "@iconify-icons/material-symbols/cancel-rounded";
import chairIcon from "@iconify-icons/material-symbols/chair-rounded";
import checkCircleIcon from "@iconify-icons/material-symbols/check-circle-rounded";
import checkIcon from "@iconify-icons/material-symbols/check";
import checklistIcon from "@iconify-icons/material-symbols/checklist-rounded";
import chevronLeftIcon from "@iconify-icons/material-symbols/chevron-left-rounded";
import chevronRightIcon from "@iconify-icons/material-symbols/chevron-right-rounded";
import closeIcon from "@iconify-icons/material-symbols/close-rounded";
import cloudUploadIcon from "@iconify-icons/material-symbols/cloud-upload";
import contractIcon from "@iconify-icons/material-symbols/contract-rounded";
import contentCopyIcon from "@iconify-icons/material-symbols/content-copy-rounded";
import cookingIcon from "@iconify-icons/material-symbols/cooking";
import cottageIcon from "@iconify-icons/material-symbols/cottage-rounded";
import countertopsIcon from "@iconify-icons/material-symbols/countertops-rounded";
import deckIcon from "@iconify-icons/material-symbols/deck-rounded";
import deleteIcon from "@iconify-icons/material-symbols/delete-rounded";
import descriptionIcon from "@iconify-icons/material-symbols/description-rounded";
import directionsBikeIcon from "@iconify-icons/material-symbols/directions-bike-rounded";
import directionsBusIcon from "@iconify-icons/material-symbols/directions-bus-rounded";
import directionsCarIcon from "@iconify-icons/material-symbols/directions-car-rounded";
import dishwasherIcon from "@iconify-icons/material-symbols/dishwasher-rounded";
import dnsIcon from "@iconify-icons/material-symbols/dns";
import domainIcon from "@iconify-icons/material-symbols/domain-rounded";
import doorFrontIcon from "@iconify-icons/material-symbols/door-front-rounded";
import downloadIcon from "@iconify-icons/material-symbols/download-rounded";
import dragIndicatorIcon from "@iconify-icons/material-symbols/drag-indicator";
import editIcon from "@iconify-icons/material-symbols/edit-rounded";
import elevatorIcon from "@iconify-icons/material-symbols/elevator-rounded";
import evStationIcon from "@iconify-icons/material-symbols/ev-station-rounded";
import favoriteIcon from "@iconify-icons/material-symbols/favorite-rounded";
import fenceIcon from "@iconify-icons/material-symbols/fence-rounded";
import fitnessCenterIcon from "@iconify-icons/material-symbols/fitness-center-rounded";
import floorIcon from "@iconify-icons/material-symbols/floor-rounded";
import formatQuoteIcon from "@iconify-icons/material-symbols/format-quote-rounded";
import foundationIcon from "@iconify-icons/material-symbols/foundation-rounded";
import garageIcon from "@iconify-icons/material-symbols/garage-rounded";
import grassIcon from "@iconify-icons/material-symbols/grass-rounded";
import groupsIcon from "@iconify-icons/material-symbols/groups-rounded";
import heatPumpIcon from "@iconify-icons/material-symbols/heat-pump";
import helpIcon from "@iconify-icons/material-symbols/help-rounded";
import holidayVillageIcon from "@iconify-icons/material-symbols/holiday-village-rounded";
import homeIcon from "@iconify-icons/material-symbols/home-rounded";
import houseIcon from "@iconify-icons/material-symbols/house-rounded";
import houseWithShieldIcon from "@iconify-icons/material-symbols/house-with-shield-rounded";
import howToRegIcon from "@iconify-icons/material-symbols/how-to-reg-rounded";
import imageIcon from "@iconify-icons/material-symbols/image-rounded";
import infoIcon from "@iconify-icons/material-symbols/info-rounded";
import inventory2Icon from "@iconify-icons/material-symbols/inventory-2-rounded";
import keyIcon from "@iconify-icons/material-symbols/key-rounded";
import keyboardArrowDownIcon from "@iconify-icons/material-symbols/keyboard-arrow-down";
import keyboardArrowUpIcon from "@iconify-icons/material-symbols/keyboard-arrow-up";
import kitchenIcon from "@iconify-icons/material-symbols/kitchen-rounded";
import lightbulbIcon from "@iconify-icons/material-symbols/lightbulb-rounded";
import listIcon from "@iconify-icons/material-symbols/list-rounded";
import localCafeIcon from "@iconify-icons/material-symbols/local-cafe-rounded";
import localGroceryStoreIcon from "@iconify-icons/material-symbols/grocery";
import localLaundryServiceIcon from "@iconify-icons/material-symbols/local-laundry-service";
import localParkingIcon from "@iconify-icons/material-symbols/local-parking-rounded";
import locationOnIcon from "@iconify-icons/material-symbols/location-on-rounded";
import logoutIcon from "@iconify-icons/material-symbols/logout-rounded";
import mailIcon from "@iconify-icons/material-symbols/mail-rounded";
import mapIcon from "@iconify-icons/material-symbols/map-rounded";
import menuBookIcon from "@iconify-icons/material-symbols/menu-book-rounded";
import menuIcon from "@iconify-icons/material-symbols/menu-rounded";
import moreHorizIcon from "@iconify-icons/material-symbols/more-horiz";
import newspaperIcon from "@iconify-icons/material-symbols/newspaper-rounded";
import northEastIcon from "@iconify-icons/material-symbols/north-east-rounded";
import notificationsIcon from "@iconify-icons/material-symbols/notifications-rounded";
import openInNewIcon from "@iconify-icons/material-symbols/open-in-new-rounded";
import openWithIcon from "@iconify-icons/material-symbols/open-with-rounded";
import pauseCircleIcon from "@iconify-icons/material-symbols/pause-circle-rounded";
import paymentsIcon from "@iconify-icons/material-symbols/payments-rounded";
import percentIcon from "@iconify-icons/material-symbols/percent-rounded";
import personAddIcon from "@iconify-icons/material-symbols/person-add-rounded";
import petsIcon from "@iconify-icons/material-symbols/pets";
import playCircleIcon from "@iconify-icons/material-symbols/play-circle-rounded";
import progressActivityIcon from "@iconify-icons/material-symbols/progress-activity";
import publicIcon from "@iconify-icons/material-symbols/public";
import realEstateAgentIcon from "@iconify-icons/material-symbols/real-estate-agent-rounded";
import refreshIcon from "@iconify-icons/material-symbols/refresh-rounded";
import removeIcon from "@iconify-icons/material-symbols/remove-rounded";
import restartAltIcon from "@iconify-icons/material-symbols/restart-alt-rounded";
import restaurantIcon from "@iconify-icons/material-symbols/restaurant-rounded";
import roofingIcon from "@iconify-icons/material-symbols/roofing-rounded";
import saveIcon from "@iconify-icons/material-symbols/save-rounded";
import scheduleIcon from "@iconify-icons/material-symbols/schedule-rounded";
import schoolIcon from "@iconify-icons/material-symbols/school-rounded";
import searchIcon from "@iconify-icons/material-symbols/search-rounded";
import sellIcon from "@iconify-icons/material-symbols/sell";
import settingsIcon from "@iconify-icons/material-symbols/settings-rounded";
import shareIcon from "@iconify-icons/material-symbols/share";
import showerIcon from "@iconify-icons/material-symbols/shower-rounded";
import shieldCheckIcon from "@iconify-icons/material-symbols/verified-user-rounded";
import smartphoneIcon from "@iconify-icons/material-symbols/smartphone";
import sofaIcon from "@iconify-icons/material-symbols/chair-rounded";
import southEastIcon from "@iconify-icons/material-symbols/south-east-rounded";
import starIcon from "@iconify-icons/material-symbols/star-rounded";
import stairsIcon from "@iconify-icons/material-symbols/stairs-rounded";
import straightenIcon from "@iconify-icons/material-symbols/straighten-rounded";
import storefrontIcon from "@iconify-icons/material-symbols/storefront-rounded";
import subwayIcon from "@iconify-icons/material-symbols/subway-rounded";
import tableChartIcon from "@iconify-icons/material-symbols/table-chart";
import taskIcon from "@iconify-icons/material-symbols/task-rounded";
import thermostatIcon from "@iconify-icons/material-symbols/thermostat-rounded";
import trendingUpIcon from "@iconify-icons/material-symbols/trending-up-rounded";
import trainIcon from "@iconify-icons/material-symbols/train-rounded";
import tramIcon from "@iconify-icons/material-symbols/tram-rounded";
import tuneIcon from "@iconify-icons/material-symbols/tune-rounded";
import unfoldMoreIcon from "@iconify-icons/material-symbols/unfold-more-rounded";
import uploadIcon from "@iconify-icons/material-symbols/upload-rounded";
import verifiedIcon from "@iconify-icons/material-symbols/verified-rounded";
import videocamIcon from "@iconify-icons/material-symbols/videocam-rounded";
import villaIcon from "@iconify-icons/material-symbols/villa-rounded";
import visibilityIcon from "@iconify-icons/material-symbols/visibility-rounded";
import visibilityOffIcon from "@iconify-icons/material-symbols/visibility-off-rounded";
import accountCircleIcon from "@iconify-icons/material-symbols/account-circle";
import walletIcon from "@iconify-icons/material-symbols/account-balance-wallet";
import warningIcon from "@iconify-icons/material-symbols/warning-rounded";
import waterDropIcon from "@iconify-icons/material-symbols/water-drop-rounded";
import webAssetIcon from "@iconify-icons/material-symbols/web-asset";
import wifiIcon from "@iconify-icons/material-symbols/wifi-rounded";
import workspacePremiumIcon from "@iconify-icons/material-symbols/workspace-premium-rounded";
import wcIcon from "@iconify-icons/material-symbols/wc-rounded";
import { cn } from "@/lib/utils";

type MaterialSymbolData = {
  left?: number;
  top?: number;
  width?: number;
  height?: number;
  body: string;
};

export type AppIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
  absoluteStrokeWidth?: boolean;
};
export type AppIcon = React.ForwardRefExoticComponent<
  AppIconProps & React.RefAttributes<SVGSVGElement>
>;
export type LucideIcon = AppIcon;

function createMaterialSymbol(icon: MaterialSymbolData, displayName: string): AppIcon {
  const MaterialSymbol = React.forwardRef<SVGSVGElement, AppIconProps>(
    (
      {
        className,
        "aria-label": ariaLabel,
        role,
        size,
        absoluteStrokeWidth: _absoluteStrokeWidth,
        strokeWidth,
        ...props
      },
      ref
    ) => (
      <svg
        ref={ref}
        width={size ?? "1em"}
        height={size ?? "1em"}
        viewBox={`${icon.left ?? 0} ${icon.top ?? 0} ${icon.width ?? 24} ${icon.height ?? 24}`}
        fill="currentColor"
        focusable="false"
        aria-hidden={ariaLabel ? undefined : true}
        aria-label={ariaLabel}
        role={role ?? (ariaLabel ? "img" : undefined)}
        strokeWidth={strokeWidth}
        className={cn("inline-block shrink-0", className)}
        {...props}
        dangerouslySetInnerHTML={{ __html: icon.body }}
      />
    )
  );

  MaterialSymbol.displayName = displayName;
  return MaterialSymbol;
}

export const Accessible = createMaterialSymbol(accessibleIcon, "Accessible");
export const ActivityIcon = createMaterialSymbol(activityIcon, "ActivityIcon");
export const AlertTriangle = createMaterialSymbol(warningIcon, "AlertTriangle");
export const AppWindow = createMaterialSymbol(webAssetIcon, "AppWindow");
export const ArrowDown = createMaterialSymbol(arrowDownwardIcon, "ArrowDown");
export const ArrowDownRight = createMaterialSymbol(southEastIcon, "ArrowDownRight");
export const ArrowLeft = createMaterialSymbol(arrowBackIcon, "ArrowLeft");
export const ArrowRight = createMaterialSymbol(arrowForwardIcon, "ArrowRight");
export const ArrowUp = createMaterialSymbol(arrowUpwardIcon, "ArrowUp");
export const ArrowUpRight = createMaterialSymbol(northEastIcon, "ArrowUpRight");
export const BadgeCheck = createMaterialSymbol(verifiedIcon, "BadgeCheck");
export const Balcony = createMaterialSymbol(balconyIcon, "Balcony");
export const BarChart3 = createMaterialSymbol(barChartIcon, "BarChart3");
export const BarChart3Icon = createMaterialSymbol(barChartIcon, "BarChart3Icon");
export const Bath = createMaterialSymbol(bathtubIcon, "Bath");
export const Bathroom = createMaterialSymbol(bathroomIcon, "Bathroom");
export const Bed = createMaterialSymbol(bedIcon, "Bed");
export const BedroomChild = createMaterialSymbol(bedroomChildIcon, "BedroomChild");
export const BedroomParent = createMaterialSymbol(bedroomParentIcon, "BedroomParent");
export const Bell = createMaterialSymbol(notificationsIcon, "Bell");
export const Bike = createMaterialSymbol(directionsBikeIcon, "Bike");
export const Bolt = createMaterialSymbol(boltIcon, "Bolt");
export const BookOpen = createMaterialSymbol(menuBookIcon, "BookOpen");
export const Building2 = createMaterialSymbol(apartmentIcon, "Building2");
export const Building2Icon = createMaterialSymbol(apartmentIcon, "Building2Icon");
export const Bus = createMaterialSymbol(directionsBusIcon, "Bus");
export const CalendarDays = createMaterialSymbol(calendarMonthIcon, "CalendarDays");
export const Car = createMaterialSymbol(directionsCarIcon, "Car");
export const Cat = createMaterialSymbol(petsIcon, "Cat");
export const Check = createMaterialSymbol(checkIcon, "Check");
export const CheckCircle = createMaterialSymbol(checkCircleIcon, "CheckCircle");
export const CheckCircle2Icon = createMaterialSymbol(checkCircleIcon, "CheckCircle2Icon");
export const CheckIcon = createMaterialSymbol(checkIcon, "CheckIcon");
export const ChevronDown = createMaterialSymbol(keyboardArrowDownIcon, "ChevronDown");
export const ChevronDownIcon = createMaterialSymbol(keyboardArrowDownIcon, "ChevronDownIcon");
export const ChevronLeft = createMaterialSymbol(chevronLeftIcon, "ChevronLeft");
export const ChevronRight = createMaterialSymbol(chevronRightIcon, "ChevronRight");
export const ChevronRightIcon = createMaterialSymbol(chevronRightIcon, "ChevronRightIcon");
export const ChevronsUpDown = createMaterialSymbol(unfoldMoreIcon, "ChevronsUpDown");
export const ChevronUpIcon = createMaterialSymbol(keyboardArrowUpIcon, "ChevronUpIcon");
export const CircleCheck = createMaterialSymbol(checkCircleIcon, "CircleCheck");
export const CircleCheckIcon = createMaterialSymbol(checkCircleIcon, "CircleCheckIcon");
export const CircleIcon = createMaterialSymbol(removeIcon, "CircleIcon");
export const CirclePause = createMaterialSymbol(pauseCircleIcon, "CirclePause");
export const CircleQuestionMark = createMaterialSymbol(helpIcon, "CircleQuestionMark");
export const Clock3 = createMaterialSymbol(scheduleIcon, "Clock3");
export const Clock3Icon = createMaterialSymbol(scheduleIcon, "Clock3Icon");
export const Contract = createMaterialSymbol(contractIcon, "Contract");
export const CookingPot = createMaterialSymbol(cookingIcon, "CookingPot");
export const Copy = createMaterialSymbol(contentCopyIcon, "Copy");
export const Cottage = createMaterialSymbol(cottageIcon, "Cottage");
export const Countertops = createMaterialSymbol(countertopsIcon, "Countertops");
export const Deck = createMaterialSymbol(deckIcon, "Deck");
export const Download01 = createMaterialSymbol(downloadIcon, "Download01");
export const Dishwasher = createMaterialSymbol(dishwasherIcon, "Dishwasher");
export const Domain = createMaterialSymbol(domainIcon, "Domain");
export const DoorFront = createMaterialSymbol(doorFrontIcon, "DoorFront");
export const Edit03 = createMaterialSymbol(editIcon, "Edit03");
export const Edit3 = createMaterialSymbol(editIcon, "Edit3");
export const Elevator = createMaterialSymbol(elevatorIcon, "Elevator");
export const EvStation = createMaterialSymbol(evStationIcon, "EvStation");
export const ExternalLink = createMaterialSymbol(openInNewIcon, "ExternalLink");
export const Eye = createMaterialSymbol(visibilityIcon, "Eye");
export const EyeIcon = createMaterialSymbol(visibilityIcon, "EyeIcon");
export const EyeOff = createMaterialSymbol(visibilityOffIcon, "EyeOff");
export const EyeOffIcon = createMaterialSymbol(visibilityOffIcon, "EyeOffIcon");
export const Facebook = createMaterialSymbol(simpleFacebookIcon, "Facebook");
export const FaFacebook = createMaterialSymbol(simpleFacebookIcon, "FaFacebook");
export const FaInstagram = createMaterialSymbol(simpleInstagramIcon, "FaInstagram");
export const FaLinkedin = createMaterialSymbol(simpleLinkedinIcon, "FaLinkedin");
export const FaTiktok = createMaterialSymbol(simpleTiktokIcon, "FaTiktok");
export const FaYoutube = createMaterialSymbol(simpleYoutubeIcon, "FaYoutube");
export const File05 = createMaterialSymbol(descriptionIcon, "File05");
export const FileCheck2 = createMaterialSymbol(taskIcon, "FileCheck2");
export const FileSpreadsheetIcon = createMaterialSymbol(tableChartIcon, "FileSpreadsheetIcon");
export const FileText = createMaterialSymbol(articleIcon, "FileText");
export const FileUser = createMaterialSymbol(assignmentIndIcon, "FileUser");
export const Fence = createMaterialSymbol(fenceIcon, "Fence");
export const FitnessCenter = createMaterialSymbol(fitnessCenterIcon, "FitnessCenter");
export const Floor = createMaterialSymbol(floorIcon, "Floor");
export const Foundation = createMaterialSymbol(foundationIcon, "Foundation");
export const Garage = createMaterialSymbol(garageIcon, "Garage");
export const Globe = createMaterialSymbol(publicIcon, "Globe");
export const GraduationCap = createMaterialSymbol(schoolIcon, "GraduationCap");
export const GraduationCapIcon = createMaterialSymbol(schoolIcon, "GraduationCapIcon");
export const Grass = createMaterialSymbol(grassIcon, "Grass");
export const Grocery = createMaterialSymbol(localGroceryStoreIcon, "Grocery");
export const GripVertical = createMaterialSymbol(dragIndicatorIcon, "GripVertical");
export const Heart = createMaterialSymbol(favoriteIcon, "Heart");
export const HeatPump = createMaterialSymbol(heatPumpIcon, "HeatPump");
export const HelpCircle = createMaterialSymbol(helpIcon, "HelpCircle");
export const HolidayVillage = createMaterialSymbol(holidayVillageIcon, "HolidayVillage");
export const Home = createMaterialSymbol(homeIcon, "Home");
export const HomeIcon = createMaterialSymbol(homeIcon, "HomeIcon");
export const House = createMaterialSymbol(houseIcon, "House");
export const HouseShield = createMaterialSymbol(houseWithShieldIcon, "HouseShield");
export const IconChevronDown = createMaterialSymbol(keyboardArrowDownIcon, "IconChevronDown");
export const IconMenu2 = createMaterialSymbol(menuIcon, "IconMenu2");
export const IconX = createMaterialSymbol(closeIcon, "IconX");
export const ImageIcon = createMaterialSymbol(imageIcon, "ImageIcon");
export const ImagePlus = createMaterialSymbol(addPhotoAlternateIcon, "ImagePlus");
export const Info = createMaterialSymbol(infoIcon, "Info");
export const InfoIcon = createMaterialSymbol(infoIcon, "InfoIcon");
export const Instagram = createMaterialSymbol(simpleInstagramIcon, "Instagram");
export const Inventory2 = createMaterialSymbol(inventory2Icon, "Inventory2");
export const KeyRound = createMaterialSymbol(keyIcon, "KeyRound");
export const Kitchen = createMaterialSymbol(kitchenIcon, "Kitchen");
export const Linkedin = createMaterialSymbol(simpleLinkedinIcon, "Linkedin");
export const Lightbulb = createMaterialSymbol(lightbulbIcon, "Lightbulb");
export const List = createMaterialSymbol(listIcon, "List");
export const ListChecks = createMaterialSymbol(checklistIcon, "ListChecks");
export const Loader2 = createMaterialSymbol(progressActivityIcon, "Loader2");
export const Loader2Icon = createMaterialSymbol(progressActivityIcon, "Loader2Icon");
export const LocalCafe = createMaterialSymbol(localCafeIcon, "LocalCafe");
export const LogOut = createMaterialSymbol(logoutIcon, "LogOut");
export const Mail = createMaterialSymbol(mailIcon, "Mail");
export const MailIcon = createMaterialSymbol(mailIcon, "MailIcon");
export const Map = createMaterialSymbol(mapIcon, "Map");
export const MapIcon = createMaterialSymbol(mapIcon, "MapIcon");
export const MapPin = createMaterialSymbol(locationOnIcon, "MapPin");
export const MapPinIcon = createMaterialSymbol(locationOnIcon, "MapPinIcon");
export const Menu = createMaterialSymbol(menuIcon, "Menu");
export const Minus = createMaterialSymbol(removeIcon, "Minus");
export const MoreHorizontal = createMaterialSymbol(moreHorizIcon, "MoreHorizontal");
export const MoreHorizontalIcon = createMaterialSymbol(moreHorizIcon, "MoreHorizontalIcon");
export const MousePointerClick = createMaterialSymbol(adsClickIcon, "MousePointerClick");
export const Move = createMaterialSymbol(openWithIcon, "Move");
export const Newspaper = createMaterialSymbol(newspaperIcon, "Newspaper");
export const OctagonXIcon = createMaterialSymbol(cancelIcon, "OctagonXIcon");
export const Parking = createMaterialSymbol(localParkingIcon, "Parking");
export const Payments = createMaterialSymbol(paymentsIcon, "Payments");
export const Pencil = createMaterialSymbol(editIcon, "Pencil");
export const PencilLine = createMaterialSymbol(editIcon, "PencilLine");
export const Percent = createMaterialSymbol(percentIcon, "Percent");
export const Phone = createMaterialSymbol(callIcon, "Phone");
export const PlayCircle = createMaterialSymbol(playCircleIcon, "PlayCircle");
export const Plus = createMaterialSymbol(addIcon, "Plus");
export const Quote = createMaterialSymbol(formatQuoteIcon, "Quote");
export const RealEstateAgent = createMaterialSymbol(realEstateAgentIcon, "RealEstateAgent");
export const RefreshCw = createMaterialSymbol(refreshIcon, "RefreshCw");
export const RefreshCwIcon = createMaterialSymbol(refreshIcon, "RefreshCwIcon");
export const Restaurant = createMaterialSymbol(restaurantIcon, "Restaurant");
export const Roofing = createMaterialSymbol(roofingIcon, "Roofing");
export const RotateCcw = createMaterialSymbol(restartAltIcon, "RotateCcw");
export const Ruler = createMaterialSymbol(straightenIcon, "Ruler");
export const Save = createMaterialSymbol(saveIcon, "Save");
export const SaveIcon = createMaterialSymbol(saveIcon, "SaveIcon");
export const SchoolIcon = createMaterialSymbol(schoolIcon, "SchoolIcon");
export const Search = createMaterialSymbol(searchIcon, "Search");
export const SearchIcon = createMaterialSymbol(searchIcon, "SearchIcon");
export const Server = createMaterialSymbol(dnsIcon, "Server");
export const Settings = createMaterialSymbol(settingsIcon, "Settings");
export const Share2 = createMaterialSymbol(shareIcon, "Share2");
export const ShieldCheck = createMaterialSymbol(shieldCheckIcon, "ShieldCheck");
export const ShieldCheckIcon = createMaterialSymbol(shieldCheckIcon, "ShieldCheckIcon");
export const Shower = createMaterialSymbol(showerIcon, "Shower");
export const SiThreads = createMaterialSymbol(simpleThreadsIcon, "SiThreads");
export const SlidersHorizontal = createMaterialSymbol(tuneIcon, "SlidersHorizontal");
export const Smartphone = createMaterialSymbol(smartphoneIcon, "Smartphone");
export const Sofa = createMaterialSymbol(sofaIcon, "Sofa");
export const Sparkles = createMaterialSymbol(autoAwesomeIcon, "Sparkles");
export const Stairs = createMaterialSymbol(stairsIcon, "Stairs");
export const Star = createMaterialSymbol(starIcon, "Star");
export const Storefront = createMaterialSymbol(storefrontIcon, "Storefront");
export const Subway = createMaterialSymbol(subwayIcon, "Subway");
export const TagsIcon = createMaterialSymbol(sellIcon, "TagsIcon");
export const Thermostat = createMaterialSymbol(thermostatIcon, "Thermostat");
export const Trash01 = createMaterialSymbol(deleteIcon, "Trash01");
export const Trash2 = createMaterialSymbol(deleteIcon, "Trash2");
export const Trash2Icon = createMaterialSymbol(deleteIcon, "Trash2Icon");
export const TrendingUp = createMaterialSymbol(trendingUpIcon, "TrendingUp");
export const TriangleAlertIcon = createMaterialSymbol(warningIcon, "TriangleAlertIcon");
export const Train = createMaterialSymbol(trainIcon, "Train");
export const Tram = createMaterialSymbol(tramIcon, "Tram");
export const Twitter = createMaterialSymbol(simpleXIcon, "Twitter");
export const Upload = createMaterialSymbol(uploadIcon, "Upload");
export const UploadCloud02 = createMaterialSymbol(cloudUploadIcon, "UploadCloud02");
export const UploadIcon = createMaterialSymbol(uploadIcon, "UploadIcon");
export const UserCheck = createMaterialSymbol(howToRegIcon, "UserCheck");
export const UserCircle = createMaterialSymbol(accountCircleIcon, "UserCircle");
export const UserPlus = createMaterialSymbol(personAddIcon, "UserPlus");
export const Users = createMaterialSymbol(groupsIcon, "Users");
export const Users2 = createMaterialSymbol(groupsIcon, "Users2");
export const UsersIcon = createMaterialSymbol(groupsIcon, "UsersIcon");
export const UsersRound = createMaterialSymbol(groupsIcon, "UsersRound");
export const Video = createMaterialSymbol(videocamIcon, "Video");
export const Villa = createMaterialSymbol(villaIcon, "Villa");
export const WalletCards = createMaterialSymbol(walletIcon, "WalletCards");
export const WashingMachine = createMaterialSymbol(localLaundryServiceIcon, "WashingMachine");
export const WaterDrop = createMaterialSymbol(waterDropIcon, "WaterDrop");
export const Wc = createMaterialSymbol(wcIcon, "Wc");
export const Wifi = createMaterialSymbol(wifiIcon, "Wifi");
export const WorkspacePremium = createMaterialSymbol(workspacePremiumIcon, "WorkspacePremium");
export const X = createMaterialSymbol(closeIcon, "X");
export const XCircle = createMaterialSymbol(cancelIcon, "XCircle");
export const XCircleIcon = createMaterialSymbol(cancelIcon, "XCircleIcon");
export const XClose = createMaterialSymbol(closeIcon, "XClose");
export const XIcon = createMaterialSymbol(closeIcon, "XIcon");
